import request from "../utils/requests";

export const getCatRead = () => request.get('/api/sa-categories').catch((err) => ({ err }));
export const getTableCatRead = (catId) => request.get(`/api/sa-category/${catId}/tables`).catch((err) => ({ err }));
export const getTableReadDetails = (tableid, start, take) => request.get(`/api/sa-table/${tableid}/details?start=${start}&take=${take}`).catch((err) => ({err}));